/**
 * Stripe決済セッションを作成してCheckout URLを返す
 * @param {string} userId - Supabase の auth.uid()
 * @param {string} userEmail - ユーザーのメールアドレス（任意）
 * @returns {Promise<string>} Stripe Checkout URL
 */
/**
 * クレジットパック購入セッションを作成
 * @param {string} userId
 * @param {string} userEmail
 * @param {'5'|'10'} pack - 5回パック or 10回パック
 * @returns {Promise<string>} Stripe Checkout URL
 */
export async function createCreditCheckoutSession(userId, userEmail, pack) {
  const res = await fetch('/api/create-credit-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, userEmail, pack }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'クレジット購入セッションの作成に失敗しました');
  }

  const { url } = await res.json();
  return url;
}

export async function createCheckoutSession(userId, userEmail) {
  const res = await fetch('/api/create-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, userEmail }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || '決済セッションの作成に失敗しました');
  }

  const { url } = await res.json();
  return url;
}
